import { format } from 'date-fns';
import { convertUTCToTimezone } from '@betgames/bg-tools';
import { DEFAULT_DATE_FORMAT } from '@bg-shared/constants/dateFormats';

export const getTodayDate = (timezone: number, dateFormat = DEFAULT_DATE_FORMAT): string =>
    format(convertUTCToTimezone(Date.now(), timezone), dateFormat);
